// @flow
import * as React from 'react';
import {ImArrowRight2} from "react-icons/im";
import LogoPic from "../Assets/Images/logo.png";
import {useNavigate} from "react-router-dom";
import {LiaSignOutAltSolid} from "react-icons/lia";
import {LuUserRound} from "react-icons/lu";


export default function Header(props) {
    const navigate = useNavigate();

    const [hasToken, setHasToken] = React.useState(false);

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(token) {
            setHasToken(true)
        }
    }, []);

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }
    return (
        <React.Fragment>
            <nav className="navbar navbar-expand-lg  " style={{background:'#F8F9FA'}}>
                <div className="container">
                    <a className="navbar-brand" href="https://cheapship.ca/" rel='noreferrer' >
                        <img src={LogoPic} alt="CheapShip" className="rounded mx-auto d-block  " width='120'/>
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                            aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                {
                                    hasToken && <button className="nav-link " aria-current="page" onClick={() => {
                                            navigate('/requests')
                                        }}>My Shipments</button>




                                }

                            </li>
                            {
                                hasToken &&
                            <li className="nav-item">
                            <button className="nav-link " aria-current="page" onClick={() => {
                                    navigate('/edit-profile')
                                }}>Edit Profile
                                </button>
                            </li>
                            }
                            <li className="nav-item">
                                <a href='https://cheapship.ca/destinations' className="nav-link " aria-current="page" > Get Qoute
                                </a>
                            </li>



                        </ul>

                        <div>
                            {
                                hasToken ?
                                <span className="nav-item">
                                    <button className="nav-link text-danger" aria-current="page" onClick={() => {
                                        onExitClick()
                                    }}>

                                        Exit
                                         <LiaSignOutAltSolid className='text-big-2 mx-2' />
                                    </button>
                                </span> :
                                    <span>
                                         <button className="nav-link " aria-current="page" onClick={() => {
                                             navigate('/login')
                                         }}>
<LuUserRound className='text-big-2 mx-2' />
                                             Login

                                         </button>
                                    </span>
                            }
                        </div>
                    </div>
                </div>
            </nav>


        </React.Fragment>
    );
};